module.exports = __webpack_public_path__ + "media/AUDIO-15.c0a1c4c3.mp3";